export interface IdentityVerificationResultState {
  title?: string;
  message?: string;
}

const stateKey = 'identityVerificationResultState';

export class IdentityVerificationResultStateHelper {
  static get(): IdentityVerificationResultState | null {
	return sessionStorage.getItem(stateKey) ? JSON.parse(sessionStorage.getItem(stateKey)) : null;
  }

  static set(state: IdentityVerificationResultState): void {
    sessionStorage.setItem(stateKey, JSON.stringify(state));
  }

  static clear(): void {
    sessionStorage.removeItem(stateKey);
  }
}